"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disclaimer = exports.Subtotal = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Subtotal = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontFamily: 'roboto',
  fontSize: 5,
  lineHeight: 1.5,
  mb: 0
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-weight: 500;\n"], ["\n  font-weight: 500;\n"])));
exports.Subtotal = Subtotal;
var Disclaimer = (0, _styledComponents["default"])(_slice.Text).attrs({
  fontSize: 3,
  lineHeight: 1.2
})(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.grey500;
});
exports.Disclaimer = Disclaimer;
var templateObject_1, templateObject_2;